import { tv } from '~/utils/tv'

export const linkVariants = tv({
  base: 'letter-spacing-default inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md rounded-pill border-action-border-neutral-tertiary-enabled bg-action-fill-neutral-tertiary-enabled px-fourpulse text-text-neutral hover:border-action-border-neutral-tertiary-hovered hover:bg-action-fill-neutral-tertiary-hovered focus:border-action-border-focused focus:border-halfpulse active:border-action-border-neutral-tertiary-pressed active:bg-action-fill-neutral-tertiary-pressed focus:active:border-action-border-focused',
  variants: {
    size: {
      md: 'h-medium min-w-medium font-semibold text-threepulse leading-medium',
      ml: 'h-mediumlarge min-w-mediumlarge font-semibold text-threeandhalfpulse leading-small',
    },
    disabled: {
      true: 'cursor-not-allowed border-action-border-neutral-tertiary-disabled bg-action-fill-neutral-tertiary-disabled text-text-neutral-disabled hover:bg-action-fill-neutral-tertiary-disabled active:bg-action-fill-neutral-tertiary-disabled',
      false: '',
    },
    full: {
      true: 'w-full',
    },
    withIcon: {
      true: 'pl-1',
    },
  },
  defaultVariants: {
    size: 'md',
  },
})
export const labelLinkVariants = tv({
  base: 'inline-flex h-small items-center justify-center underline decoration-solid',
})
export const iconLinkVariants = tv({
  base: 'pl-onepulse no-underline',
})
